export default __webpack_public_path__ + "static/media/1.d1cb8699.jpg";